import { render } from "./priceInfo.vue?vue&type=template&id=69f0043c&ts=true"
import script from "./priceInfo.vue?vue&type=script&lang=ts"
export * from "./priceInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__